import React from 'react';
import PropTypes from 'prop-types';
import SelectField from '../select-field/SelectField';
import { errorStyle } from './styles';

const renderSelectField = ({ meta: { visited, touched, error }, input, ...custom }) => (
  <React.Fragment>
    <SelectField
      {...custom}
      {...input}
    />
    {(touched || visited) && (error && (
      <span style={errorStyle}>
        {error}
      </span>
    ))}
  </React.Fragment>
);

renderSelectField.defaultProps = {
  input: null,
  meta: {
    visited: false,
    error: '',
    touched: false,
  },
};

renderSelectField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  meta: PropTypes.shape({
    visited: PropTypes.bool,
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};
export default renderSelectField;
